import { render } from "./profit_sharing.vue?vue&type=template&id=1881a1a4&scoped=true"
import script from "./profit_sharing.vue?vue&type=script&lang=js"
export * from "./profit_sharing.vue?vue&type=script&lang=js"

import "./profit_sharing.vue?vue&type=style&index=0&id=1881a1a4&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1881a1a4"]])

export default __exports__